<template>
	<div class="common-layout">
		<el-container>
			<el-header>
				<Header />
			</el-header>
			<el-container>
				<el-aside class="Nav">
					<Navbar />
				</el-aside>
				<el-main class="Main">
					<router-view v-slot="{ Component }">
						<transition name="fade-transform" mode="out-in">
							<component :is="Component"/>
						</transition>
					</router-view>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import {Navbar,Header} from "./Components";

export default {
	name: 'Home',
	components: {
		Navbar,
		Header
	},
	data(){
		return{
			ValueData:'111',
		}
	},
	methods:{
		
	},
	mounted(){
		
	}
}
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>